import { useI18N } from "@sundae/react-hooks";
import { toolkitCx } from "@sundae/ui-toolkit";
import { AssetAmount } from "@sundaeswap/asset";
import { FC } from "react";
import { joyrideSelectors } from "../../constants/joyride.constants";
import { testIds } from "../../constants/testIds.constants";
import { EOrderTransactionBuilderState, useOrderContext } from "../../stores/OrderContext";

export interface ISwapMaxButtonProps {
  assetValue: string;
  maxAmount: AssetAmount;
  onClick: (maxAssetBalance: string) => void;
}

const SwapMaxButton: FC<ISwapMaxButtonProps> = ({ assetValue, maxAmount, onClick }) => {
  const { t } = useI18N();
  const {
    state: {
      derived: { transaction },
    },
  } = useOrderContext();
  const maxAssetBalance = maxAmount.value.toString();

  if (assetValue === maxAssetBalance) return null;

  return (
    <div
      data-testid={testIds.assetAmountBox.maxButton}
      data-guide-selector={joyrideSelectors.guides.exchange.maxButton}
    >
      (
      <button
        onClick={() => {
          if (transaction?.state === EOrderTransactionBuilderState.BUILD) return;
          onClick(maxAssetBalance);
        }}
        className={toolkitCx.layout.text.primary}
      >
        {t("max", { ns: "common" })}
      </button>
      )
    </div>
  );
};

export default SwapMaxButton;
